import { combineReducers } from 'redux'
import LoginReducer from './Login/LoginReducer'

export default combineReducers({
    LoginReducer,
  })